import React, {useState, useEffect} from 'react';
import {Howl} from 'howler';
import './FlashCard.css'
import Select from "react-select";
import {_get} from "../ApiModule/ApiClient";

function FlashCard() {
    const [words, setWords] = useState([]);
    const [word, setWord] = useState({});
    const [howlMap, setHowlMap] = useState({});
    const [lessons, setLessons] = useState([]);
    const [lesson, setLesson] = useState({});

    const handleChangeWord = () => {
        if(word.guid === undefined) {
            return;
        }
        let nextWord = words[Math.floor(Math.random() * words.length)];
        while (nextWord.guid === word.guid) {
            nextWord = words[Math.floor(Math.random() * words.length)];
        }
        setWord(nextWord);

    };

    const toAudioUri = (transcriptionId) => {
        return `/api/transcriptions/${transcriptionId}/audio`
    };

    const handlePlayWord = async (word) => {
        if(word.guid === undefined) {
            return;
        }

        howlMap[toAudioUri(word.transcriptionId)].play(word.guid);
    };

    const toHowlOptions = (howlerList) => {
        let howlerOpts = {};
        howlerList.forEach(h => howlerOpts[h.src[0]] = new Howl(h));
        return howlerOpts;
    };

    const handleChangeLesson = async (lesson) => {
        setLesson(lesson);
        await fetchLesson(lesson.value);
    };

    async function fetchLesson(lessonGuid) {
        try {
            const response = await _get(`/api/words?lessonId=${lessonGuid}`);
            const data = await response.json();
            const howlerList = data.howlerList;
            const wordSet = data.words.wordSet;
            const wordSetLen = wordSet.length;
            const howlOptsList = toHowlOptions(howlerList);

            setHowlMap(howlOptsList);
            setWords(wordSet);
            setWord(wordSet[Math.floor(Math.random() * wordSetLen)])
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const fetchData = async () => {
        let lessonOpts = [];
        let lessonOpt = {};
        try {
            const response = await _get('/api/lessons');
            const data = await response.json();
            lessonOpts = data.map(l => {
                let opt = {};
                opt.value = l.lessonId;
                opt.label = l.lessonName;
                return opt;
            });
            lessonOpt = lessonOpts[Math.floor(Math.random() * lessonOpts.length)];

            setLessons(lessonOpts);
            setLesson(lessonOpt);
        } catch (error) {
            console.error('Error fetching data:', error);
            // Handle errors
        }

        if(!lessonOpt) {
            console.log('No lessons to load');
            return;
        }

        await fetchLesson(lessonOpt.value);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="flash-card">
            {word &&
            <React.Fragment>
                <div className="">
                    {lesson &&
                    <Select
                        options={lessons}
                        onChange={handleChangeLesson}
                        isMulti={false}
                        pl
                        closeMenuOnSelect={true}
                    />}
                </div>
                <div className="main-word">
                    <h3>{word.akanText}</h3>
                    <i className="bi bi-volume-up-fill pointer" onClick={() => handlePlayWord(word)}/>
                </div>
                <p>{word.englishText}</p>
                <button className="btn btn-primary" onClick={() => handleChangeWord()}>
                    Next
                </button>
            </React.Fragment>}
        </div>
    );
};

export default FlashCard;
